import { Outlet } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function PortalLayout() {
  return (
    <>
      <Header />
      <main
        className="container"
        style={{
          paddingBlock: "clamp(2rem, 5vw, 3.5rem)",
          minHeight: "60vh",
        }}
      >
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
